export const devEvnFormFill = () => {
  try {
    const nameArray = document?.getElementsByClassName(
      'w-commerce-commercecheckoutbillingfullname'
    ) as HTMLCollectionOf<HTMLInputElement>;

    nameArray[0].value = 'Han Solo';

    const phoneNumberArray = document?.getElementsByClassName(
      'w-commerce-commercecheckoutadditionaltextinput'
    ) as HTMLCollectionOf<HTMLInputElement>;

    phoneNumberArray[0].value = '5558675309';

    const addressArray = document?.getElementsByClassName(
      'w-commerce-commercecheckoutbillingstreetaddress'
    ) as HTMLCollectionOf<HTMLInputElement>;

    addressArray[0].value = 'A Galaxy';

    const cityArray = document?.getElementsByClassName(
      'w-commerce-commercecheckoutbillingcity'
    ) as HTMLCollectionOf<HTMLInputElement>;

    cityArray[0].value = 'Far Far Away';

    const stateArray = document?.getElementsByClassName(
      'w-commerce-commercecheckoutbillingstateprovince'
    ) as HTMLCollectionOf<HTMLInputElement>;

    stateArray[0].value = 'SF';

    const zipArray = document?.getElementsByClassName(
      'w-commerce-commercecheckoutbillingzippostalcode'
    ) as HTMLCollectionOf<HTMLInputElement>;

    zipArray[0].value = '111111';
  } catch (error) {
    throw error;
  }
};
